import './alert.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Container from './container';

const Alert = forwardRef((props, ref) => {
  const className = classNames({
    alert: true,
    [`alert-${props.type}`]: true,
    [props.className]: props.className,
  });

  return (
    <Container ref={ref} className={className}>
      {props.children}
    </Container>
  );
});

Alert.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'primary', 'secondary', 'warning', 'danger']),
  className: PropTypes.string,
  children: PropTypes.node,
};

Alert.defaultProps = {
  type: 'default',
};

export default Alert;
